module.exports = __webpack_public_path__ + "img/centralairunit.bc65ca58.svg";